import styled from "styled-components";
import Chip from "../../../../components/basics/Chip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { Grid, FormControlLabel } from "@material-ui/core";
const opensans = (props) => props.theme.fonts.opensans;

export const StyledChipForm = styled(Chip)`
  width: 100%;
  font-size: 14px !important;
`;

export const StyledChipTemplates = styled(Chip)`
  width: 100%;
  font-size: 12px !important;
`;

export const IconHelp = styled(HelpOutlineIcon)`
  padding: 20px 0px 0px 2px;
  font-size: 18px;
  font-size: 1.3rem;
`;

export const DivHeandleEmail = styled.div`
  width: 100%;
  .toolbarClassName {
    margin-top: 1vh;
  }
  .editorClassName {
    border: solid lightgray;
    margin-bottom: 1vh;
    min-height: 150px;
  }
`;

export const Line = styled(Grid)`
  margin-bottom: 15px !important;
  margin-top: 5px !important;
`;

export const HeaderAccordion = styled.div`
  width: 100%;
  .MuiChip-root {
    padding: 0;
    margin: 0;
    width: 100%;
  }
`;

export const CheckItem = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-family: ${opensans}, "sans-serif";
  }
`;
